import React, { useContext, useEffect, useState } from "react";
import { contextpass } from "../App";
import about from "../images/aboutme-inner.png";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { SlDocs } from "react-icons/sl";
import { Button, Modal } from "react-bootstrap";
import { Helmet } from "react-helmet";

function About() {
  const { pass } = useContext(contextpass);
  const [mode] = pass;
  const [show, setShow] = useState(false);

  const resumebtn = () => {
    setShow(true);
  };
  // const navto=useNavigate()
  const resumeDownload = () => {
    // using Java Script method to get PDF file
    fetch("Mubashir-Resume.pdf").then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "Mubashir-Resume.pdf";
        alink.click();
      });
    });
    setShow(false);
  };
  // onscrollanimation start
  const anime1 = {
    visible: {
      opacity: 1,
      x: 0,
      transition: { ease: "easeInOut", duration: 0.9 },
    },
    hidden: { opacity: 0, x: -100 },
  };
  const anime2 = {
    visible: {
      opacity: 1,
      x: 0,
      transition: { ease: "easeInOut", duration: 0.9 },
    },
    hidden: { opacity: 0, x: 100 },
  };

  const control = useAnimation();
  const [ref, inView] = useInView();
  useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);
  // onscrollanimation end
  return (
    <section
      className={
        mode === true
          ? "align-items-center row bg-6"
          : "align-items-center row bg-2"
      }
    >
      <Helmet>
        <meta
          name="description"
          content="As a front-end developer, design and development are very important
to me. I think my technical expertise and sense of aesthetics make
me a well-rounded developer who can handle any challenge."
        />
        <title>About - Muhammed Mubashir</title>
      </Helmet>

      <motion.div
        className="col-lg-6 col-md-12 col-sm-12"
        ref={ref}
        variants={anime1}
        initial="hidden"
        animate={control}
      >
        <div className="inner-sec">
          <h2 className="sec-head">Web Developer</h2>
          <ul className="p-info">
            <li>
              <span>First Name : </span>
              <span>Muhammed</span>
            </li>
            <li>
              <span>Last Name : </span>
              <span>Mubashir</span>
            </li>
            <li>
              <span>Age : </span>
              <span>23 Years</span>
            </li>
            <li>
              <span>Nationality : </span>
              <span>Indian</span>
            </li>
            <li>
              <span>Freelance : </span>
              <span className="available">Available</span>
            </li>
            <li>
              <span>Current Address : </span>
              <span>Dubai, UAE</span>
            </li>
            <li>
              <span>Phone : </span>
              <span>
                <a href="tel:+971566797822">+971 56 679 7822</a>
              </span>
            </li>
            {/* <li>
          <span>Email : </span>
          <span>akmmubashir@gmail.com</span>
        </li>
        <li>
          <span>Skype : </span>
          <span>mubashir.muhammed.639</span>
        </li> */}
            <li>
              <span>Langages : </span>
              <span>English, Malayalam</span>
            </li>
          </ul>
          <motion.button
            initial={{ opacity: 0.6 }}
            whileHover={{
              scale: 1.1,
              transition: { duration: 1 },
            }}
            whileTap={{ scale: 0.9 }}
            whileInView={{ opacity: 1 }}
            className="sec-btn btn"
            onClick={resumebtn}
          >
            Download CV
            <span className="ms-2">
              <SlDocs />
            </span>
          </motion.button>
        </div>
      </motion.div>
      <motion.div
        className="col-lg-6 col-md-12 col-sm-12 text-center"
        ref={ref}
        variants={anime2}
        initial="hidden"
        animate={control}
      >
        <img src={about} alt="about" className="sec-img-w" />
      </motion.div>
      <Modal show={show} centered>
        <Modal.Body>
          <h5 className="text-dark" style={{ fontWeight: "400" }}>
            To download the resume, simply click the "Confirm" button.
          </h5>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              setShow(false);
            }}
          >
            Cancel
          </Button>
          <Button variant="success" onClick={resumeDownload}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
}

export default About;
